import { defineMessages } from 'react-intl';

const messages = defineMessages({
  afterOrEqual: 'Data nie może być mniejsza niż dzisiejsza',
});

export default {
  'validation.after_or_equal': messages.afterOrEqual.defaultMessage,
};
